<template>
    <div class="UpdateGroupComponent">

        

            <b-form-group id="input-group-GroupName" :label="lang.label_GroupName" label-for="input-GroupName">
                <b-form-input id="input-GroupName" v-model="form.groupName" :placeholder="lang.placeholder_GroupName"
                    size="sm" required aria-describedby="input-GroupName-feedback"
                    :state="validation_GroupName"></b-form-input>

                <b-form-invalid-feedback id="input-GroupName-feedback" :state="validation_GroupName">
                    {{ lang.validinfo_GroupName }}
                </b-form-invalid-feedback>
            </b-form-group>

                    
        
    </div>
</template>

<script>



export default {
    name: "UpdateGroupComponent",
    components: {



    },
    props: {
        lang: Object
    },
    data() {
        return {
            form: {

                groupId: this.$store.getters.createGroupForm.groupId,
                groupName: this.$store.getters.createGroupForm.groupName,
                permissions: this.$store.getters.createGroupForm.permissions
                
            },
            permissions: [],
            permissionsSelected: [],
            
        }
    },
    computed: {
        permissionsOptions() {

            let permissionsOptions = [];
            

            for (let i = 0, lei = this.permissions.length; i < lei; i++) {

                let obj = {
                    text: this.permissions[i].name,
                    value: this.permissions[i].permissionId
                }
                
                permissionsOptions.push(obj);
            }
            return permissionsOptions;
        },
        validation_GroupName() {


            if (this.form.groupName.length == 0) {
                return null;
            }
            return this.form.groupName.length > 0
        },
        
    },
    created() {
        // let vue = this;

        // this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPermissions")
        //     .then((result) => {
        //         console.log(result.data)
        //         if (result.status == "OK") {

        //             if (result.data != null) {

        //                 vue.permissions = result.data;

                        
        //                 vue.permissionsSelected = vue.form.permissions;

        //             }
        //         }

        //     })

    },
    updated() {

        
        let obj = {
            groupId: this.form.permissionId,
            groupName: this.form.groupName,
            permissions: this.permissionsSelected
        }
        this.$store.commit("CREATEGROUPFORM", obj);
        
        
    },
    methods: {

    }
}
</script>
<style lang="scss">
.UpdateGroupComponent {}
</style>



// WEBPACK FOOTER //
// src/components/shared/UpdateGroupComponent.vue